import useMetadata from './use-metadata';
import useReferenceData from 'hooks/use-reference-data';
import useTranslation from 'hooks/use-translation';
import useURLs from 'hooks/use-url';

export default function useIsAppLoaded(): boolean {
  const urls = useURLs();
  const referenceData = useReferenceData();
  const translation = useTranslation();
  const metadata = useMetadata();
  return !!urls && !!referenceData && !!translation && !!metadata;
}
